'use client'

import {useCallback, useEffect, useState} from 'react'
import {useSession} from '~/auth/AuthProvider'
import useSnackbar from '~/components/snackbar/useSnackbar'
import {getSoftwareIndicatorEvaluationPeriods} from './apiSoftwareIndicator'

export function useSoftwareIndicatorEvaluationPeriods() {
  const {token} = useSession()
  const {showErrorMessage} = useSnackbar()
  const [loading, setLoading] = useState(true)

  const [evaluationPeriods, setEvaluationPeriods] = useState<string[]>([])
  const [latestPeriod, setLatestPeriod] = useState<string | undefined>(undefined)

  useEffect(() => {
    fetchEvaluationPeriods()
  }, [])

  useEffect(() => {
    getLatestPeriod()
  }, [evaluationPeriods])

  const fetchEvaluationPeriods = useCallback(async () => {
    setLoading(true)
    const data = await getSoftwareIndicatorEvaluationPeriods({token})
    setEvaluationPeriods(data.map(period => period.year))
    setLoading(false)
  }, [token])

  const getLatestPeriod = () => {
    if (evaluationPeriods) {
      const periods = evaluationPeriods.map(period => Number(period)).sort()
      setLatestPeriod(String(periods[periods.length-1]))
    }
  }

  return {
    loading,
    evaluationPeriods,
    latestPeriod
  }
}
